/**
 * AreaAutoDetect.js
 *
 * Maps the current browser pathname to a report area enum value.
 * Used by the report context builder to pre-fill the area field.
 *
 * Areas: 'chat' | 'rag' | 'builder' | 'onboarding' | 'admin' | 'other'
 */

const ROUTE_AREA_MAP = [
  // Onboarding routes
  { prefix: '/onboarding', area: 'onboarding' },

  // Builder routes
  { prefix: '/agents/builder', area: 'builder' },
  { prefix: '/explore', area: 'builder' },

  // Knowledge/RAG routes
  { prefix: '/editor/knowledge', area: 'rag' },
  { prefix: '/collections', area: 'rag' },

  // Admin routes
  { prefix: '/admin', area: 'admin' },

  // Settings (other)
  { prefix: '/settings', area: 'other' },

  // Editor/plans
  { prefix: '/editor', area: 'other' },

  // Default chat (root or /chat)
  { prefix: '/', area: 'chat' },
];

/**
 * Detects the report area from a pathname.
 * @param {string} pathname - window.location.pathname (e.g. '/agents/builder/123')
 * @returns {string} Area enum value
 */
export function detectArea(pathname) {
  if (!pathname) return 'other';

  const normalized = pathname.toLowerCase();

  for (const { prefix, area } of ROUTE_AREA_MAP) {
    if (normalized.startsWith(prefix)) {
      return area;
    }
  }

  return 'other';
}
